package org.zq.astrock_ai.ui.research.gushi

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.zq.astrock_ai.api.StockCodes
import org.zq.astrock_ai.api.dto.QuantResultDto
import org.zq.astrock_ai.api.dto.QuantScanItemDto
import org.zq.astrock_ai.api.dto.QuantScanResponseDto
import org.zq.astrock_ai.api.dto.RecommendResponseDto
import org.zq.astrock_ai.data.StockProfile
import org.zq.astrock_ai.network.MarketRepository
import org.zq.astrock_ai.platform.LocalAlertNotifier
import org.zq.astrock_ai.storage.QuantScanPrefs
import org.zq.astrock_ai.storage.QuantScanPrefsStorage
import org.zq.astrock_ai.storage.QuantScanSignalStorage
import org.zq.astrock_ai.storage.WatchlistLocalStorage
import org.zq.astrock_ai.ui.research.gushi.components.AddHoldingDialog
import org.zq.astrock_ai.ui.research.gushi.components.AddStockToWatchlistDialog
import org.zq.astrock_ai.ui.research.gushi.components.AiAssistantPanel
import org.zq.astrock_ai.ui.research.gushi.components.AiRecommendDialog
import org.zq.astrock_ai.ui.research.gushi.components.ExportTextDialog
import org.zq.astrock_ai.ui.research.gushi.components.HoldingAlertDialog
import org.zq.astrock_ai.ui.research.gushi.components.LicenseGenerateDialog
import org.zq.astrock_ai.ui.research.gushi.components.PaperTradeDialog
import org.zq.astrock_ai.ui.research.gushi.components.PortfolioBoardDialog
import org.zq.astrock_ai.ui.research.gushi.components.RecommendHistoryDialog
import org.zq.astrock_ai.ui.research.gushi.components.RecommendLicenseDialog
import org.zq.astrock_ai.ui.research.gushi.components.ResearchBackupDialog
import org.zq.astrock_ai.ui.research.gushi.components.ResearchPanel
import org.zq.astrock_ai.ui.research.gushi.components.ScanHistoryDialog
import org.zq.astrock_ai.ui.research.gushi.components.TopBar
import org.zq.astrock_ai.ui.research.gushi.components.WatchlistPanel
import org.zq.astrock_ai.ui.research.gushi.data.AdaptiveLearningResult
import org.zq.astrock_ai.ui.research.gushi.data.AdaptiveStockLearner
import org.zq.astrock_ai.ui.research.gushi.data.BrowseHistoryStore
import org.zq.astrock_ai.ui.research.gushi.data.DemoData
import org.zq.astrock_ai.ui.research.gushi.data.DeviceLicenseStore
import org.zq.astrock_ai.ui.research.gushi.data.HoldingsStore
import org.zq.astrock_ai.ui.research.gushi.data.WorkbenchLayoutPrefsStore
import org.zq.astrock_ai.ui.research.gushi.data.applyPaperTradeToHoldings
import org.zq.astrock_ai.ui.research.gushi.data.exportPaperSummaryText
import org.zq.astrock_ai.ui.research.gushi.data.PaperTradeStore
import org.zq.astrock_ai.ui.research.gushi.data.RecommendHistoryStore
import org.zq.astrock_ai.ui.research.gushi.data.RecommendTodayStore
import org.zq.astrock_ai.ui.research.gushi.data.ScanChangeKind
import org.zq.astrock_ai.ui.research.gushi.data.ScanHistoryStore
import org.zq.astrock_ai.ui.research.gushi.data.StockTrendMetrics
import org.zq.astrock_ai.ui.research.gushi.data.WatchlistGroupsStore
import org.zq.astrock_ai.ui.research.gushi.data.buildPortfolioSummary
import org.zq.astrock_ai.ui.research.gushi.data.buildScanAlertText
import org.zq.astrock_ai.ui.research.gushi.data.diffScanChanges
import org.zq.astrock_ai.ui.research.gushi.data.exportHoldingsText
import org.zq.astrock_ai.ui.research.gushi.data.exportScanText
import org.zq.astrock_ai.ui.research.gushi.data.toSignalMap
import org.zq.astrock_ai.ui.research.gushi.data.computeTrendMetrics
import org.zq.astrock_ai.ui.research.gushi.data.toCandles
import org.zq.astrock_ai.ui.research.gushi.data.toResearchStockItem
import org.zq.astrock_ai.ui.research.gushi.data.withAdaptiveLearning
import org.zq.astrock_ai.ui.research.gushi.model.Candle
import org.zq.astrock_ai.ui.research.gushi.model.ChartTradeMarker
import org.zq.astrock_ai.ui.research.gushi.model.HoldingPosition
import org.zq.astrock_ai.ui.research.gushi.model.StockItem
import org.zq.astrock_ai.ui.research.gushi.model.TrendDirection
import org.zq.astrock_ai.util.currentTimeMillis
import org.zq.astrock_ai.util.formatDecimal

/**
 * 暂时关闭荐股认证码弹框，任何人可直接用荐股。改回 true 后恢复核销流程（对话框未删除）。
 */
private const val REQUIRE_RECOMMEND_LICENSE = false

/**
 * 暂时关闭「今日本机缓存」：每次点推荐都重新跑 AI 分析。
 * 改回 true 后恢复：同一天同市场+风格直接展示缓存，只有刷新才重跑。
 */
private const val REUSE_TODAY_RECOMMEND_CACHE = false

@Composable
fun StockWorkbenchApp(
    onBack: (() -> Unit)? = null,
    loggedInPhone: String? = null,
    superAdmin: Boolean = false,
    staffRole: String = "user",
    onLogout: (() -> Unit)? = null,
) {
    val repository = remember { MarketRepository() }
    val scope = rememberCoroutineScope()
    val demoMeta = remember { DemoData.stocks.associateBy { it.code } }

    var watchlistCodes by remember {
        mutableStateOf(
            WatchlistLocalStorage.load().ifEmpty { StockCodes.defaultWatchlist },
        )
    }
    var stocks by remember { mutableStateOf(DemoData.stocks) }
    var selectedCode by remember {
        mutableStateOf(watchlistCodes.firstOrNull() ?: DemoData.stocks.first().code)
    }
    var isLive by remember { mutableStateOf(false) }
    var candles by remember { mutableStateOf<List<Candle>>(emptyList()) }
    var klineLive by remember { mutableStateOf(false) }
    var adaptiveLearning by remember { mutableStateOf(AdaptiveLearningResult()) }
    var holdings by remember { mutableStateOf(HoldingsStore.load()) }
    var showHoldingDialog by remember { mutableStateOf(false) }
    var showHoldingAlertDialog by remember { mutableStateOf(false) }
    var showAddWatchDialog by remember { mutableStateOf(false) }
    var quantTradeMarkers by remember { mutableStateOf<List<ChartTradeMarker>>(emptyList()) }
    var firedHoldingAlerts by remember { mutableStateOf<Set<String>>(emptySet()) }
    var addableStocks by remember { mutableStateOf<List<StockProfile>>(emptyList()) }
    var addableLoading by remember { mutableStateOf(false) }
    var quantScanByCode by remember { mutableStateOf<Map<String, QuantScanItemDto>>(emptyMap()) }
    var quantScanChanges by remember { mutableStateOf<Map<String, ScanChangeKind>>(emptyMap()) }
    var quantScanSummary by remember { mutableStateOf<String?>(null) }
    var quantScanAlert by remember { mutableStateOf<String?>(null) }
    var quantScanning by remember { mutableStateOf(false) }
    var showScanHistory by remember { mutableStateOf(false) }
    var showRecommendHistory by remember { mutableStateOf(false) }
    var recommendHistoryEntries by remember { mutableStateOf(RecommendHistoryStore.load()) }
    var browseEntries by remember { mutableStateOf(BrowseHistoryStore.load()) }
    var browseStocks by remember { mutableStateOf<List<StockItem>>(emptyList()) }
    var watchlistPaneTab by remember { mutableStateOf("自选") }
    var showPortfolioBoard by remember { mutableStateOf(false) }
    var showPaperTrades by remember { mutableStateOf(false) }
    var showBackup by remember { mutableStateOf(false) }
    var showAiRecommend by remember { mutableStateOf(false) }
    var showRecommendLicense by remember { mutableStateOf(false) }
    var licensePlanLabel by remember { mutableStateOf("") }
    var licenseExpiresLabel by remember { mutableStateOf("") }
    var showLicenseGenerate by remember { mutableStateOf(false) }
    var recommendLicenseHint by remember { mutableStateOf("") }
    var aiRecommendLoading by remember { mutableStateOf(false) }
    var aiRecommendResult by remember { mutableStateOf<RecommendResponseDto?>(null) }
    var aiRecommendProgress by remember { mutableStateOf<org.zq.astrock_ai.api.dto.RecommendProgressDto?>(null) }
    var aiRecommendBoards by remember {
        mutableStateOf(setOf(org.zq.astrock_ai.api.RecommendBoards.CYB))
    }
    var aiRecommendStyle by remember {
        mutableStateOf(org.zq.astrock_ai.api.RecommendStyle.OVERNIGHT)
    }
    var aiRecommendScanEpoch by remember { mutableStateOf(0) }
    var exportTitle by remember { mutableStateOf<String?>(null) }
    var exportContent by remember { mutableStateOf("") }
    var scanHistoryEntries by remember { mutableStateOf(ScanHistoryStore.load()) }
    var paperTradeEntries by remember { mutableStateOf(PaperTradeStore.load()) }
    var groupByCode by remember { mutableStateOf(WatchlistGroupsStore.load()) }
    var scanPrefs by remember { mutableStateOf(QuantScanPrefsStorage.load()) }
    var layoutPrefs by remember { mutableStateOf(WorkbenchLayoutPrefsStore.load()) }
    var watchlistFilterRequest by remember { mutableStateOf<String?>(null) }
    var openResearchRequest by remember { mutableStateOf(false) }
    /** 递增后强制切到「研究」Tab，避免布尔位卡住导致点了不跳转 */
    var openResearchNonce by remember { mutableStateOf(0) }
    val portfolioSummary = remember(holdings, stocks) {
        buildPortfolioSummary(holdings, stocks)
    }

    fun cycleStockGroup(code: String) {
        val current = WatchlistGroupsStore.groupOf(groupByCode, code)
        val next = WatchlistGroupsStore.cycle(current)
        groupByCode = groupByCode + (code to next)
        WatchlistGroupsStore.save(groupByCode)
    }

    fun updateGroupMap(next: Map<String, String>) {
        groupByCode = next
        WatchlistGroupsStore.save(next)
    }

    fun reloadAfterBackupImport() {
        watchlistCodes = WatchlistLocalStorage.load().ifEmpty { watchlistCodes }
        holdings = HoldingsStore.load()
        paperTradeEntries = PaperTradeStore.load()
        recommendHistoryEntries = RecommendHistoryStore.load()
        browseEntries = BrowseHistoryStore.load()
        groupByCode = WatchlistGroupsStore.load()
        scanPrefs = QuantScanPrefsStorage.load()
        scanHistoryEntries = ScanHistoryStore.load()
        layoutPrefs = WorkbenchLayoutPrefsStore.load()
    }

    fun applyLicenseUi(
        planLabel: String = "",
        expiresAtMs: Long = 0L,
        expiresAtLabel: String = "",
        token: String = "",
    ) {
        val now = currentTimeMillis()
        val active = now < expiresAtMs && (token.isNotBlank() || planLabel.isNotBlank())
        if (active) {
            licensePlanLabel = planLabel
            licenseExpiresLabel = when {
                expiresAtMs > 0L -> org.zq.astrock_ai.util.formatShanghaiDateTime(expiresAtMs)
                else -> expiresAtLabel
            }
        } else {
            licensePlanLabel = ""
            licenseExpiresLabel = ""
        }
    }

    fun refreshLicenseUiFromStore() {
        val saved = DeviceLicenseStore.load()
        applyLicenseUi(
            planLabel = saved?.planLabel.orEmpty(),
            expiresAtMs = saved?.expiresAtMs ?: 0L,
            expiresAtLabel = saved?.expiresAtLabel.orEmpty(),
            token = saved?.token.orEmpty(),
        )
    }

    fun resultMatchesSelection(
        result: RecommendResponseDto?,
        boards: Set<String>,
        style: String,
    ): Boolean {
        if (result == null) return false
        val wantBoard = org.zq.astrock_ai.api.RecommendBoards.encode(
            org.zq.astrock_ai.api.RecommendBoards.normalizeSelection(boards),
        )
        val gotBoard = org.zq.astrock_ai.api.RecommendBoards.encode(
            org.zq.astrock_ai.api.RecommendBoards.normalizeSelection(result.boards.toSet()),
        )
        val wantStyle = org.zq.astrock_ai.api.RecommendStyle.parse(style)
        val gotStyle = org.zq.astrock_ai.api.RecommendStyle.parse(result.tradeStyle)
        return wantBoard == gotBoard && wantStyle == gotStyle
    }

    fun startAiRecommendScan() {
        showAiRecommend = true
        val gen = aiRecommendScanEpoch + 1
        aiRecommendScanEpoch = gen
        aiRecommendLoading = true
        aiRecommendResult = null
        aiRecommendProgress = org.zq.astrock_ai.api.dto.RecommendProgressDto(
            stage = "排队启动",
            detail = "正在启动筛选与打分…",
            percent = 1,
            steps = listOf("排队启动"),
        )
        aiRecommendBoards = org.zq.astrock_ai.api.RecommendBoards.normalizeSelection(aiRecommendBoards)
        val boardsNow = aiRecommendBoards
        val styleNow = aiRecommendStyle
        scope.launch {
            val boardsParam = org.zq.astrock_ai.api.RecommendBoards.encode(boardsNow)
            val result = repository.recommendTopWithProgress(5, boardsParam, styleNow) { prog ->
                if (gen == aiRecommendScanEpoch) aiRecommendProgress = prog
            }
            if (gen != aiRecommendScanEpoch) return@launch
            aiRecommendResult = result
            runCatching {
                RecommendTodayStore.save(boardsNow, styleNow, result)
                RecommendHistoryStore.append(result)
                recommendHistoryEntries = RecommendHistoryStore.load()
            }
            aiRecommendLoading = false
        }
    }

    /** 打开荐股弹框：只展示，不自动开跑；点「刷新」才 [startAiRecommendScan]。 */
    fun openAiRecommend() {
        scope.launch {
            if (REQUIRE_RECOMMEND_LICENSE) {
                val status = repository.fetchLicenseStatus()
                if (!status.ok) {
                    if (status.message.contains("到期")) {
                        DeviceLicenseStore.clearToken()
                    }
                    refreshLicenseUiFromStore()
                    recommendLicenseHint = status.message
                    showRecommendLicense = true
                    return@launch
                }
                DeviceLicenseStore.save(
                    token = status.token,
                    plan = status.plan,
                    planLabel = status.planLabel,
                    expiresAtMs = status.expiresAtMs,
                    expiresAtLabel = status.expiresAtLabel,
                )
                applyLicenseUi(status.planLabel, status.expiresAtMs, status.expiresAtLabel, status.token)
            }
            showAiRecommend = true
            // 未在扫描时：有内存结果则保留；否则可展示今日缓存（仍不自动细算）
            if (!aiRecommendLoading && aiRecommendResult == null && REUSE_TODAY_RECOMMEND_CACHE) {
                val cached = RecommendTodayStore.loadToday(aiRecommendBoards, aiRecommendStyle)
                if (cached != null && resultMatchesSelection(cached, aiRecommendBoards, aiRecommendStyle)) {
                    aiRecommendResult = cached
                    aiRecommendProgress = null
                }
            }
        }
    }

    fun runAiRecommend() {
        openAiRecommend()
    }

    LaunchedEffect(Unit) {
        refreshLicenseUiFromStore()
        val status = repository.fetchLicenseStatus()
        if (status.ok) {
            DeviceLicenseStore.save(
                token = status.token,
                plan = status.plan,
                planLabel = status.planLabel,
                expiresAtMs = status.expiresAtMs,
                expiresAtLabel = status.expiresAtLabel,
            )
            applyLicenseUi(status.planLabel, status.expiresAtMs, status.expiresAtLabel, status.token)
        } else if (status.message.contains("到期")) {
            DeviceLicenseStore.clearToken()
            refreshLicenseUiFromStore()
        }
    }

    LaunchedEffect(watchlistCodes) {
        WatchlistLocalStorage.save(watchlistCodes)
        while (true) {
            val profiles = repository.loadWatchlist(watchlistCodes)
            if (profiles.isNotEmpty()) {
                var next = profiles.map { profile ->
                    profile.toResearchStockItem(demoMeta[profile.code])
                }
                isLive = repository.isLive
                if (next.none { it.code == selectedCode }) {
                    val seed = stocks.firstOrNull { it.code == selectedCode }
                    if (seed != null && selectedCode in watchlistCodes) {
                        next = listOf(seed) + next
                    } else if (
                        selectedCode !in watchlistCodes &&
                        browseEntries.none { it.code == selectedCode }
                    ) {
                        selectedCode = next.first().code
                    }
                }
                stocks = next
            } else {
                stocks = DemoData.stocks.filter { it.code in watchlistCodes }
                isLive = false
            }
            delay(30_000)
        }
    }

    LaunchedEffect(showAddWatchDialog, watchlistCodes) {
        if (showAddWatchDialog) {
            addableLoading = true
            addableStocks = repository.loadAddableStocks(watchlistCodes.toSet())
            addableLoading = false
        }
    }

    LaunchedEffect(selectedCode) {
        candles = emptyList()
        klineLive = false
        adaptiveLearning = AdaptiveLearningResult()
        while (true) {
            val bars = repository.loadKlineBars(selectedCode, limit = 240)
            if (bars.isNotEmpty()) {
                val liveCandles = bars.toCandles()
                val benchmark = repository.loadBenchmark(selectedCode, limit = 240)
                candles = liveCandles
                adaptiveLearning = AdaptiveStockLearner.evaluate(
                    code = selectedCode,
                    candles = liveCandles,
                    benchmarkCandles = benchmark.bars.toCandles(),
                    benchmarkName = benchmark.name,
                )
                klineLive = true
            } else {
                val stock = stocks.find { it.code == selectedCode } ?: DemoData.stocks.first()
                val base = stock.price.replace(",", "").toDoubleOrNull() ?: 5.18
                candles = DemoData.candles(stock.code.takeLast(2).toIntOrNull() ?: 0, base)
                klineLive = false
            }
            delay(60_000)
        }
    }

    LaunchedEffect(watchlistCodes) {
        while (true) {
            // 进入页面后立即训练一次；每批最多 3 只，兼顾速度与行情接口限流。
            watchlistCodes.chunked(3).forEach { batch ->
                coroutineScope {
                    batch.map { code ->
                        async {
                            val bars = repository.loadKlineBars(code, limit = 240)
                            if (bars.isNotEmpty()) {
                                val benchmark = repository.loadBenchmark(code, limit = 240)
                                AdaptiveStockLearner.evaluate(
                                    code = code,
                                    candles = bars.toCandles(),
                                    benchmarkCandles = benchmark.bars.toCandles(),
                                    benchmarkName = benchmark.name,
                                )
                            }
                        }
                    }.awaitAll()
                }
                delay(150)
            }
            delay(60_000L)
        }
    }

    val selectedStock = stocks.firstOrNull { it.code == selectedCode }
        ?: browseStocks.firstOrNull { it.code == selectedCode }
        ?: stocks.firstOrNull()
        ?: browseStocks.firstOrNull()
        ?: DemoData.stocks.first()
    val metrics = remember(selectedStock, candles, adaptiveLearning) {
        computeTrendMetrics(selectedStock, candles).withAdaptiveLearning(adaptiveLearning)
    }
    val currentHolding = holdings[selectedCode]

    fun openHoldingDialog() {
        showHoldingDialog = true
    }

    fun persistHoldings(next: Map<String, HoldingPosition>) {
        holdings = next
        HoldingsStore.save(next)
    }

    fun saveHolding(costPrice: Double, quantity: Int) {
        val prev = holdings[selectedStock.code]
        persistHoldings(
            holdings + (selectedStock.code to HoldingPosition(
                stockCode = selectedStock.code,
                stockName = selectedStock.name,
                costPrice = costPrice,
                quantity = quantity,
                alertPrice = prev?.alertPrice,
                alertPnlPct = prev?.alertPnlPct,
            )),
        )
        showHoldingDialog = false
    }

    fun clearHolding() {
        persistHoldings(holdings - selectedStock.code)
        showHoldingDialog = false
    }

    fun saveHoldingAlert(alertPrice: Double?, alertPnlPct: Double?) {
        val current = holdings[selectedStock.code] ?: return
        persistHoldings(
            holdings + (selectedStock.code to current.copy(
                alertPrice = alertPrice,
                alertPnlPct = alertPnlPct,
            )),
        )
        firedHoldingAlerts = firedHoldingAlerts.filterNot {
            it.startsWith("${selectedStock.code}|")
        }.toSet()
        showHoldingAlertDialog = false
    }

    fun clearHoldingAlert() {
        val current = holdings[selectedStock.code] ?: return
        persistHoldings(
            holdings + (selectedStock.code to current.copy(alertPrice = null, alertPnlPct = null)),
        )
        showHoldingAlertDialog = false
    }

    fun onQuantUpdated(result: QuantResultDto?) {
        quantTradeMarkers = result?.backtest?.tradeDetails.orEmpty().flatMap { t ->
            listOf(
                ChartTradeMarker(date = t.entryDate, price = t.entryPrice, side = "BUY"),
                ChartTradeMarker(date = t.exitDate, price = t.exitPrice, side = "SELL"),
            )
        }
    }

    // 持仓价位 / 盈亏阈值提醒（本会话去重）
    LaunchedEffect(stocks, holdings) {
        holdings.values.forEach { holding ->
            val quote = stocks.firstOrNull { it.code == holding.stockCode } ?: return@forEach
            val price = quote.price.replace(",", "").toDoubleOrNull() ?: return@forEach
            if (holding.costPrice <= 0) return@forEach
            val pnlPct = (price - holding.costPrice) / holding.costPrice * 100.0
            holding.alertPrice?.let { target ->
                val key = "${holding.stockCode}|price|$target"
                if (key !in firedHoldingAlerts && price <= target) {
                    firedHoldingAlerts = firedHoldingAlerts + key
                    val body = "${holding.stockName} 现价 ${formatDecimal(price)} ≤ 提醒价 ${formatDecimal(target)}"
                    LocalAlertNotifier.notify("持仓价格提醒", body)
                }
            }
            holding.alertPnlPct?.let { threshold ->
                val key = "${holding.stockCode}|pnl|$threshold"
                val hit = if (threshold >= 0) pnlPct >= threshold else pnlPct <= threshold
                if (key !in firedHoldingAlerts && hit) {
                    firedHoldingAlerts = firedHoldingAlerts + key
                    val body = "${holding.stockName} 浮盈亏 ${formatDecimal(pnlPct)}% 触及 ${formatDecimal(threshold)}%"
                    LocalAlertNotifier.notify("持仓盈亏提醒", body)
                }
            }
        }
    }

    fun addToWatchlist(profile: StockProfile) {
        val code = profile.code
        if (code !in watchlistCodes) {
            watchlistCodes = watchlistCodes + code
            stocks = (stocks + profile.toResearchStockItem(demoMeta[code]))
                .distinctBy { it.code }
        }
        selectedCode = code
        showAddWatchDialog = false
    }

    fun resolveStockName(code: String, fallback: String = ""): String {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        return fallback.ifBlank { "" }.ifBlank {
            stocks.firstOrNull { it.code == normalized }?.name.orEmpty()
        }.ifBlank {
            browseStocks.firstOrNull { it.code == normalized }?.name.orEmpty()
        }.ifBlank {
            aiRecommendResult?.stocks?.firstOrNull { it.code == normalized }?.name.orEmpty()
        }.ifBlank {
            aiRecommendResult?.limitUps?.firstOrNull { it.code == normalized }?.name.orEmpty()
        }.ifBlank {
            aiRecommendResult?.nearMisses?.firstOrNull { it.code == normalized }?.name.orEmpty()
        }.ifBlank {
            recommendHistoryEntries.asSequence()
                .flatMap { it.stocks.asSequence() }
                .firstOrNull { it.code == normalized }
                ?.name
                .orEmpty()
        }.ifBlank {
            browseEntries.firstOrNull { it.code == normalized }?.name.orEmpty()
        }
    }

    fun seedStockItem(code: String, name: String): StockItem {
        stocks.firstOrNull { it.code == code }?.let { existing ->
            return if (name.isNotBlank() && existing.name != name) existing.copy(name = name) else existing
        }
        browseStocks.firstOrNull { it.code == code }?.let { existing ->
            return if (name.isNotBlank() && existing.name != name) existing.copy(name = name) else existing
        }
        val market = if (code.startsWith("6")) "SH" else "SZ"
        val seed = demoMeta[code]
        val rec = aiRecommendResult?.stocks?.firstOrNull { it.code == code }
        val hist = recommendHistoryEntries.asSequence()
            .flatMap { it.stocks.asSequence() }
            .firstOrNull { it.code == code }
        val price = rec?.price?.takeIf { it > 0 } ?: hist?.price?.takeIf { it > 0 }
        return StockItem(
            name = name.ifBlank { seed?.name ?: code },
            code = code,
            marketCode = seed?.marketCode ?: "$code.$market",
            price = price?.let { formatDecimal(it) } ?: seed?.price ?: "--",
            changeAmount = seed?.changeAmount ?: "--",
            changePercent = rec?.changePct?.let { "${formatDecimal(it)}%" }
                ?: seed?.changePercent ?: "--",
            direction = when {
                (rec?.changePct ?: 0.0) > 0 -> TrendDirection.UP
                (rec?.changePct ?: 0.0) < 0 -> TrendDirection.DOWN
                else -> seed?.direction ?: TrendDirection.FLAT
            },
            status = seed?.status ?: "待刷新",
            note = "浏览记录",
            industry = seed?.industry ?: "—",
            tags = seed?.tags ?: listOf("浏览"),
            sparkline = seed?.sparkline ?: listOf(0.4f, 0.45f, 0.5f, 0.48f, 0.52f),
        )
    }

    fun applyRecommendZones(code: String, name: String) {
        val rec = aiRecommendResult?.stocks?.firstOrNull { it.code == code } ?: return
        if ((rec.sellLow <= 0 || rec.sellHigh <= 0) && (rec.buyLow <= 0 || rec.buyHigh <= 0)) return
        quantScanByCode = quantScanByCode + (
            code to QuantScanItemDto(
                code = code,
                name = name.ifBlank { code },
                signal = rec.signal,
                strategyId = "recommend",
                reason = rec.reasons.firstOrNull().orEmpty(),
                price = rec.price,
                asOf = rec.asOf,
                source = "recommend",
                sellLow = rec.sellLow,
                sellHigh = rec.sellHigh,
                sellMethod = rec.sellMethod,
                sellConfidence = rec.sellConfidence,
                sellReasons = rec.sellReasons,
                buyLow = rec.buyLow,
                buyHigh = rec.buyHigh,
                buyMethod = rec.buyMethod,
                buyConfidence = rec.buyConfidence,
                buyReasons = rec.buyReasons,
            )
        )
    }

    fun recordBrowse(code: String, name: String = "", switchPane: Boolean = false) {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        if (normalized.length != 6) return
        val resolved = resolveStockName(normalized, name)
        browseEntries = BrowseHistoryStore.prepend(normalized, resolved)
        val item = seedStockItem(normalized, resolved)
        browseStocks = listOf(item) + browseStocks.filter { it.code != normalized }
        applyRecommendZones(normalized, resolved)
        if (switchPane) watchlistPaneTab = "浏览记录"
    }

    fun selectStock(code: String) {
        selectedCode = code
        recordBrowse(code)
    }

    fun removeFromBrowse(code: String) {
        browseEntries = BrowseHistoryStore.remove(code)
        browseStocks = browseStocks.filter { it.code != code }
        if (selectedCode == code && code !in watchlistCodes) {
            selectedCode = watchlistCodes.firstOrNull()
                ?: browseStocks.firstOrNull()?.code
                ?: selectedCode
            watchlistPaneTab = "自选"
        }
    }

    LaunchedEffect(browseEntries, stocks) {
        browseStocks = browseEntries.map { entry ->
            stocks.firstOrNull { it.code == entry.code }
                ?: browseStocks.firstOrNull { it.code == entry.code }
                ?: seedStockItem(entry.code, entry.name)
        }
    }

    fun addCodeToWatchlist(code: String, name: String) {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        if (normalized.length != 6) return
        if (normalized !in watchlistCodes) {
            watchlistCodes = (listOf(normalized) + watchlistCodes).distinct()
            if (stocks.none { it.code == normalized }) {
                val market = if (normalized.startsWith("6")) "SH" else "SZ"
                val seed = demoMeta[normalized]
                val rec = aiRecommendResult?.stocks?.firstOrNull { it.code == normalized }
                stocks = listOf(
                    StockItem(
                        name = name.ifBlank { seed?.name ?: normalized },
                        code = normalized,
                        marketCode = seed?.marketCode ?: "$normalized.$market",
                        price = rec?.price?.takeIf { it > 0 }?.let { formatDecimal(it) }
                            ?: seed?.price ?: "--",
                        changeAmount = seed?.changeAmount ?: "--",
                        changePercent = rec?.changePct?.let { "${formatDecimal(it)}%" }
                            ?: seed?.changePercent ?: "--",
                        direction = when {
                            (rec?.changePct ?: 0.0) > 0 -> TrendDirection.UP
                            (rec?.changePct ?: 0.0) < 0 -> TrendDirection.DOWN
                            else -> seed?.direction ?: TrendDirection.FLAT
                        },
                        status = seed?.status ?: "待刷新",
                        note = "荐股加入",
                        industry = seed?.industry ?: "—",
                        tags = seed?.tags ?: listOf("荐股"),
                        sparkline = seed?.sparkline ?: listOf(0.4f, 0.45f, 0.5f, 0.48f, 0.52f),
                    ),
                ) + stocks
                // 立刻写入建议买卖区，无需等下次扫描
                if (rec != null && (
                        (rec.sellLow > 0 && rec.sellHigh > 0) ||
                            (rec.buyLow > 0 && rec.buyHigh > 0)
                        )
                ) {
                    quantScanByCode = quantScanByCode + (
                        normalized to QuantScanItemDto(
                            code = normalized,
                            name = name.ifBlank { normalized },
                            signal = rec.signal,
                            strategyId = "recommend",
                            reason = rec.reasons.firstOrNull().orEmpty(),
                            price = rec.price,
                            asOf = rec.asOf,
                            source = "recommend",
                            sellLow = rec.sellLow,
                            sellHigh = rec.sellHigh,
                            sellMethod = rec.sellMethod,
                            sellConfidence = rec.sellConfidence,
                            sellReasons = rec.sellReasons,
                            buyLow = rec.buyLow,
                            buyHigh = rec.buyHigh,
                            buyMethod = rec.buyMethod,
                            buyConfidence = rec.buyConfidence,
                            buyReasons = rec.buyReasons,
                        )
                    )
                }
            }
        }
    }

    fun openStockDetail(code: String, name: String = "") {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        if (normalized.length != 6) return
        addCodeToWatchlist(normalized, resolveStockName(normalized, name))
        selectedCode = normalized
        showAiRecommend = false
        showRecommendHistory = false
        openResearchRequest = true
        openResearchNonce += 1
    }

    fun applyScanResult(result: QuantScanResponseDto) {
        val previous = QuantScanSignalStorage.load()
        val byCode = result.items.associateBy { it.code }
        val changes = diffScanChanges(previous, result.items)
        val nameByCode = (stocks.associate { it.code to it.name } +
            result.items.associate { it.code to it.name })
        quantScanByCode = byCode
        quantScanChanges = changes
        quantScanSummary = buildString {
            append("共识扫描：买 ${result.buyCount} · 卖 ${result.sellCount} · 观望 ${result.holdCount}")
            append("（${result.count} 只）")
            if (changes.isNotEmpty()) append(" · 变化 ${changes.size}")
        }
        ScanHistoryStore.append(result, changes, nameByCode)
        scanHistoryEntries = ScanHistoryStore.load()
        QuantScanSignalStorage.save(byCode.toSignalMap())
        changes.forEach { (code, kind) ->
            val item = byCode[code] ?: return@forEach
            val side = when (kind) {
                ScanChangeKind.NEW_BUY, ScanChangeKind.TO_BUY -> "BUY"
                ScanChangeKind.NEW_SELL, ScanChangeKind.TO_SELL -> "SELL"
            }
            PaperTradeStore.appendSignal(
                code = code,
                name = nameByCode[code].orEmpty(),
                side = side,
                price = item.price,
                reason = kind.label + " · " + item.reason,
                source = "scan",
            )
        }
        if (changes.isNotEmpty()) {
            paperTradeEntries = PaperTradeStore.load()
        }
        if (changes.isNotEmpty() && scanPrefs.alertEnabled) {
            val alert = buildScanAlertText(changes, result.items)
            quantScanAlert = alert
            LocalAlertNotifier.notify("自选信号变化", alert)
        }
    }

    fun runQuantScan() {
        if (quantScanning) return
        quantScanning = true
        scope.launch {
            val result = runCatching {
                repository.scanQuant(watchlistCodes, strategyId = "consensus", lookbackDays = 90)
            }.getOrNull()
            if (result != null) {
                applyScanResult(result)
            } else {
                quantScanSummary = "扫描失败，请稍后重试"
            }
            quantScanning = false
        }
    }

    fun updateScanPrefs(next: QuantScanPrefs) {
        scanPrefs = next
        QuantScanPrefsStorage.save(next)
        if (next.alertEnabled) LocalAlertNotifier.prepare()
    }

    fun activateScanAlert() {
        LocalAlertNotifier.prepare()
        val first = quantScanChanges.keys.firstOrNull()
        if (first != null) selectedCode = first
        watchlistFilterRequest = "变化"
    }

    fun openHistoryStock(code: String) {
        selectedCode = code
        watchlistFilterRequest = when (quantScanByCode[code]?.signal) {
            "BUY" -> "买信号"
            "SELL" -> "卖信号"
            else -> "变化"
        }
        showScanHistory = false
    }

    // 进入研究台后先扫一次；若开启定时复扫则按间隔循环
    LaunchedEffect(watchlistCodes, scanPrefs.autoRescanMinutes) {
        if (watchlistCodes.isEmpty()) return@LaunchedEffect
        while (true) {
            if (!quantScanning) {
                quantScanning = true
                val result = runCatching {
                    repository.scanQuant(watchlistCodes, strategyId = "consensus", lookbackDays = 90)
                }.getOrNull()
                if (result != null) applyScanResult(result)
                quantScanning = false
            }
            val minutes = scanPrefs.autoRescanMinutes
            if (minutes <= 0) break
            delay(minutes * 60_000L)
        }
    }

    fun removeFromWatchlist(code: String) {
        if (code !in watchlistCodes || watchlistCodes.size <= 1) return
        val remainingCodes = watchlistCodes.filterNot { it == code }
        watchlistCodes = remainingCodes
        stocks = stocks.filterNot { it.code == code }
        if (selectedCode == code) {
            selectedCode = remainingCodes.first()
        }
    }

    Surface(
        modifier = Modifier
            .fillMaxSize()
            .windowInsetsPadding(WindowInsets.safeDrawing),
        color = StockColors.Background,
    ) {
        Column(Modifier.fillMaxSize()) {
            TopBar(
                modifier = Modifier.fillMaxWidth(),
                onBack = onBack,
                isLive = isLive,
                loggedInPhone = loggedInPhone,
                superAdmin = superAdmin,
                staffRole = staffRole,
                licensePlanLabel = licensePlanLabel,
                licenseExpiresLabel = licenseExpiresLabel,
                onLogout = onLogout,
                onAiRecommend = { openAiRecommend() },
                onRecommendHistory = {
                    recommendHistoryEntries = RecommendHistoryStore.load()
                    showRecommendHistory = true
                },
                onGenerateLicenses = { showLicenseGenerate = true },
                onSearchCommit = { query ->
                    val hit = stocks.firstOrNull {
                        it.name.contains(query) ||
                            it.code.contains(query) ||
                            it.marketCode.contains(query, ignoreCase = true)
                    } ?: browseStocks.firstOrNull {
                        it.name.contains(query) ||
                            it.code.contains(query) ||
                            it.marketCode.contains(query, ignoreCase = true)
                    }
                    if (hit != null) {
                        selectStock(hit.code)
                        if (hit.code !in watchlistCodes) watchlistPaneTab = "浏览记录"
                    }
                },
            )

            BoxWithConstraints(Modifier.fillMaxSize()) {
                val phone = isPhoneWidth(maxWidth)
                // 手机始终紧凑 Tab，避免窄屏强开三栏导致卡顿
                val useCompact = phone || when (layoutPrefs.mode) {
                    "compact" -> true
                    "wide" -> false
                    else -> isCompactWidth(maxWidth)
                }
                if (useCompact) {
                    CompactWorkbench(
                        phoneLayout = phone,
                        stocks = stocks,
                        browseStocks = browseStocks,
                        watchlistPaneTab = watchlistPaneTab,
                        onWatchlistPaneTabChange = { watchlistPaneTab = it },
                        selectedCode = selectedCode,
                        selectedStock = selectedStock,
                        metrics = metrics,
                        isLive = isLive,
                        candles = candles,
                        adaptiveLearning = adaptiveLearning,
                        holdings = holdings,
                        scanByCode = quantScanByCode,
                        scanChanges = quantScanChanges,
                        scanSummary = quantScanSummary,
                        scanAlertText = quantScanAlert,
                        scanPrefs = scanPrefs,
                        requestedFilter = watchlistFilterRequest,
                        scanning = quantScanning,
                        onSelect = ::selectStock,
                        onAddHolding = { openHoldingDialog() },
                        onAddWatch = { showAddWatchDialog = true },
                        onAddCurrentWatch = { addCodeToWatchlist(selectedCode, selectedStock.name) },
                        onRemoveWatch = ::removeFromWatchlist,
                        onRemoveBrowse = ::removeFromBrowse,
                        onScanQuant = ::runQuantScan,
                        onDismissAlert = { quantScanAlert = null },
                        onAlertActivate = ::activateScanAlert,
                        onOpenHistory = { showScanHistory = true },
                        onOpenPortfolio = { showPortfolioBoard = true },
                        onOpenPaperTrades = {
                            paperTradeEntries = PaperTradeStore.load()
                            showPaperTrades = true
                        },
                        groupByCode = groupByCode,
                        onCycleGroup = ::cycleStockGroup,
                        onGroupMapChange = ::updateGroupMap,
                        onExportScan = {
                            exportTitle = "导出扫描 CSV"
                            exportContent = exportScanText(quantScanByCode, stocks, quantScanSummary)
                        },
                        onOpenBackup = { showBackup = true },
                        layoutLabel = WorkbenchLayoutPrefsStore.label(layoutPrefs),
                        onCycleLayout = {
                            layoutPrefs = WorkbenchLayoutPrefsStore.cycle(layoutPrefs)
                        },
                        onScanPrefsChange = ::updateScanPrefs,
                        onFilterRequestConsumed = { watchlistFilterRequest = null },
                        openResearchRequest = openResearchRequest,
                        openResearchNonce = openResearchNonce,
                        onOpenResearchConsumed = { openResearchRequest = false },
                        onSetAlert = { showHoldingAlertDialog = true },
                        tradeMarkers = quantTradeMarkers,
                        onQuantUpdated = ::onQuantUpdated,
                        watchlistCodes = watchlistCodes,
                        onScanResult = ::applyScanResult,
                        recommendReasons = aiRecommendResult?.stocks
                            ?.firstOrNull { it.code == selectedCode }
                            ?.reasons
                            .orEmpty(),
                        recommendRisks = aiRecommendResult?.stocks
                            ?.firstOrNull { it.code == selectedCode }
                            ?.risks
                            .orEmpty(),
                        recommendHistory = recommendHistoryEntries,
                    )
                } else {
                    val leftWidth = if (maxWidth >= 1500.dp) 320.dp else 280.dp
                val rightWidth = if (maxWidth >= 1500.dp) 470.dp else 390.dp

                Row(Modifier.fillMaxSize()) {
                    WatchlistPanel(
                        stocks = stocks,
                            browseStocks = browseStocks,
                            paneTab = watchlistPaneTab,
                            onPaneTabChange = { watchlistPaneTab = it },
                        selectedCode = selectedCode,
                            holdingCodes = holdings.keys,
                            scanByCode = quantScanByCode,
                            scanChanges = quantScanChanges,
                            groupByCode = groupByCode,
                            scanSummary = quantScanSummary,
                            scanAlertText = quantScanAlert,
                            scanPrefs = scanPrefs,
                            requestedFilter = watchlistFilterRequest,
                            scanning = quantScanning,
                            onSelect = ::selectStock,
                            onAddWatch = { showAddWatchDialog = true },
                            onRemoveWatch = ::removeFromWatchlist,
                            onRemoveBrowse = ::removeFromBrowse,
                            onScanQuant = ::runQuantScan,
                            onDismissAlert = { quantScanAlert = null },
                            onAlertActivate = ::activateScanAlert,
                            onOpenHistory = { showScanHistory = true },
                            onOpenPortfolio = { showPortfolioBoard = true },
                            onOpenPaperTrades = {
                                paperTradeEntries = PaperTradeStore.load()
                                showPaperTrades = true
                            },
                            onCycleGroup = ::cycleStockGroup,
                            onGroupMapChange = ::updateGroupMap,
                            onExportScan = {
                                exportTitle = "导出扫描 CSV"
                                exportContent = exportScanText(quantScanByCode, stocks, quantScanSummary)
                            },
                            onOpenBackup = { showBackup = true },
                            layoutLabel = WorkbenchLayoutPrefsStore.label(layoutPrefs),
                            onCycleLayout = {
                                layoutPrefs = WorkbenchLayoutPrefsStore.cycle(layoutPrefs)
                            },
                            onScanPrefsChange = ::updateScanPrefs,
                            onFilterRequestConsumed = { watchlistFilterRequest = null },
                            modifier = Modifier.width(leftWidth),
                    )

                    DividerLine()

                    ResearchPanel(
                        stock = selectedStock,
                            metrics = metrics,
                            isLive = isLive,
                            holding = currentHolding,
                            isInWatchlist = selectedCode in watchlistCodes,
                            canRemoveWatch = watchlistCodes.size > 1,
                            scan = quantScanByCode[selectedCode],
                            recommendReasons = aiRecommendResult?.stocks
                                ?.firstOrNull { it.code == selectedCode }
                                ?.reasons
                                .orEmpty(),
                            recommendRisks = aiRecommendResult?.stocks
                                ?.firstOrNull { it.code == selectedCode }
                                ?.risks
                                .orEmpty(),
                            tradeMarkers = quantTradeMarkers,
                            recommendHistory = recommendHistoryEntries,
                            onAddHolding = { openHoldingDialog() },
                            onAddWatch = { addCodeToWatchlist(selectedCode, selectedStock.name) },
                            onRemoveWatch = { removeFromWatchlist(selectedCode) },
                            onSetAlert = { showHoldingAlertDialog = true },
                            modifier = Modifier.weight(1f),
                    )

                    DividerLine()

                    AiAssistantPanel(
                        stock = selectedStock,
                            metrics = metrics,
                            holding = currentHolding,
                            candles = candles,
                            adaptiveLearning = adaptiveLearning,
                            watchlistCodes = watchlistCodes,
                            onEditHolding = { openHoldingDialog() },
                            onScanResult = ::applyScanResult,
                            onQuantUpdated = ::onQuantUpdated,
                            modifier = Modifier.width(rightWidth),
                        )
                    }
                }
            }
        }

        if (showHoldingDialog) {
            AddHoldingDialog(
                stock = selectedStock,
                existing = currentHolding,
                onDismiss = { showHoldingDialog = false },
                onConfirm = { cost, qty -> saveHolding(cost, qty) },
                onClear = if (currentHolding != null) ({ clearHolding() }) else null,
            )
        }

        if (showAddWatchDialog) {
            AddStockToWatchlistDialog(
                candidates = addableStocks,
                existingCodes = watchlistCodes.toSet(),
                loading = addableLoading,
                onDismiss = { showAddWatchDialog = false },
                onAdd = ::addToWatchlist,
            )
        }

        if (showScanHistory) {
            ScanHistoryDialog(
                entries = scanHistoryEntries,
                onDismiss = { showScanHistory = false },
                onSelectCode = ::openHistoryStock,
                onExportDiff = { text ->
                    exportTitle = "导出扫描差异"
                    exportContent = text
                    showScanHistory = false
                },
            )
        }

        if (showHoldingAlertDialog) {
            HoldingAlertDialog(
                stock = selectedStock,
                holding = currentHolding,
                onDismiss = { showHoldingAlertDialog = false },
                onConfirm = ::saveHoldingAlert,
                onClear = if (currentHolding?.alertPrice != null || currentHolding?.alertPnlPct != null) {
                    { clearHoldingAlert() }
                } else {
                    null
                },
            )
        }

        if (showPortfolioBoard) {
            PortfolioBoardDialog(
                summary = portfolioSummary,
                onDismiss = { showPortfolioBoard = false },
                onSelectCode = { code ->
                    selectedCode = code
                    showPortfolioBoard = false
                },
                onExport = {
                    exportTitle = "导出持仓 CSV"
                    exportContent = exportHoldingsText(portfolioSummary)
                    showPortfolioBoard = false
                },
            )
        }

        if (exportTitle != null) {
            ExportTextDialog(
                title = exportTitle!!,
                content = exportContent,
                onDismiss = { exportTitle = null },
            )
        }

        if (showPaperTrades) {
            PaperTradeDialog(
                entries = paperTradeEntries,
                onDismiss = { showPaperTrades = false },
                onSelectCode = { code ->
                    selectedCode = code
                    showPaperTrades = false
                },
                onApplyToHoldings = { list, lotSize ->
                    var next = holdings
                    list.forEach { entry ->
                        next = applyPaperTradeToHoldings(next, entry, lotSize)
                    }
                    persistHoldings(next)
                    val last = list.lastOrNull()?.code?.filter { it.isDigit() }?.takeLast(6)
                    if (last != null && last.length == 6) selectedCode = last
                },
                onExportSummary = { summaries, lotSize ->
                    exportTitle = "导出纸面汇总 CSV"
                    exportContent = exportPaperSummaryText(summaries, lotSize)
                },
                defaultCode = selectedStock.code,
                defaultName = selectedStock.name,
                onEntriesChanged = { paperTradeEntries = PaperTradeStore.load() },
            )
        }

        if (showBackup) {
            ResearchBackupDialog(
                onDismiss = { showBackup = false },
                onImported = {
                    reloadAfterBackupImport()
                    showBackup = false
                },
                onExportReady = { text ->
                    exportTitle = "研究台备份 JSON"
                    exportContent = text
                },
            )
        }

        if (showLicenseGenerate) {
            LicenseGenerateDialog(onDismiss = { showLicenseGenerate = false })
        }

        if (showRecommendLicense) {
            RecommendLicenseDialog(
                hint = recommendLicenseHint,
                onDismiss = { showRecommendLicense = false },
                onUnlocked = { result ->
                    applyLicenseUi(result.planLabel, result.expiresAtMs, result.expiresAtLabel, result.token)
                    showRecommendLicense = false
                    openAiRecommend()
                },
            )
        }

        if (showAiRecommend) {
            AiRecommendDialog(
                result = aiRecommendResult,
                loading = aiRecommendLoading,
                progress = aiRecommendProgress,
                selectedBoards = aiRecommendBoards,
                selectedStyle = aiRecommendStyle,
                watchlistCodes = watchlistCodes.toSet(),
                onDismiss = { showAiRecommend = false },
                onSelectCode = { code, name ->
                    openStockDetail(code, name)
                },
                onAddWatch = { code, name -> addCodeToWatchlist(code, name) },
                onRefresh = { startAiRecommendScan() },
                onBoardsChange = { next ->
                    val one = org.zq.astrock_ai.api.RecommendBoards.normalizeSelection(next)
                    if (one == aiRecommendBoards) return@AiRecommendDialog
                    aiRecommendBoards = one
                    // 换板只改筛选，点「刷新」再分析
                },
                onStyleChange = { next ->
                    val one = org.zq.astrock_ai.api.RecommendStyle.parse(next)
                    if (one == aiRecommendStyle) return@AiRecommendDialog
                    aiRecommendStyle = one
                    // 换风格只改筛选，点「刷新」再分析
                },
            )
        }

        if (showRecommendHistory) {
            RecommendHistoryDialog(
                entries = recommendHistoryEntries,
                onDismiss = { showRecommendHistory = false },
                onSelectCode = { code, name ->
                    openStockDetail(code, name)
                },
                loadCurrentPrices = { codes ->
                    repository.loadWatchlist(codes).associate { profile ->
                        profile.code to (
                            profile.tradePrice.toDoubleOrNull()
                                ?: profile.price.removePrefix("¥").replace(",", "").toDoubleOrNull()
                                ?: 0.0
                            )
                    }.filterValues { it > 0 }
                },
            )
        }
    }
}

@Composable
private fun CompactWorkbench(
    phoneLayout: Boolean = false,
    stocks: List<StockItem>,
    browseStocks: List<StockItem> = emptyList(),
    watchlistPaneTab: String = "自选",
    onWatchlistPaneTabChange: (String) -> Unit = {},
    selectedCode: String,
    selectedStock: StockItem,
    metrics: StockTrendMetrics,
    isLive: Boolean,
    candles: List<Candle>,
    adaptiveLearning: AdaptiveLearningResult,
    holdings: Map<String, HoldingPosition>,
    scanByCode: Map<String, QuantScanItemDto>,
    scanChanges: Map<String, ScanChangeKind>,
    groupByCode: Map<String, String>,
    scanSummary: String?,
    scanAlertText: String?,
    scanPrefs: QuantScanPrefs,
    requestedFilter: String?,
    scanning: Boolean,
    onSelect: (String) -> Unit,
    onAddHolding: () -> Unit,
    onAddWatch: () -> Unit,
    onAddCurrentWatch: () -> Unit = onAddWatch,
    onRemoveWatch: (String) -> Unit,
    onRemoveBrowse: (String) -> Unit = {},
    onScanQuant: () -> Unit,
    onDismissAlert: () -> Unit,
    onAlertActivate: () -> Unit,
    onOpenHistory: () -> Unit,
    onOpenPortfolio: () -> Unit,
    onOpenPaperTrades: () -> Unit,
    onCycleGroup: (String) -> Unit,
    onGroupMapChange: (Map<String, String>) -> Unit,
    onExportScan: () -> Unit,
    onOpenBackup: () -> Unit,
    layoutLabel: String,
    onCycleLayout: () -> Unit,
    onScanPrefsChange: (QuantScanPrefs) -> Unit,
    onFilterRequestConsumed: () -> Unit,
    openResearchRequest: Boolean = false,
    openResearchNonce: Int = 0,
    onOpenResearchConsumed: () -> Unit = {},
    onSetAlert: () -> Unit,
    tradeMarkers: List<ChartTradeMarker>,
    onQuantUpdated: (QuantResultDto?) -> Unit,
    watchlistCodes: List<String>,
    onScanResult: (QuantScanResponseDto) -> Unit,
    recommendReasons: List<String> = emptyList(),
    recommendRisks: List<String> = emptyList(),
    recommendHistory: List<org.zq.astrock_ai.ui.research.gushi.data.RecommendHistorySnapshot> = emptyList(),
) {
    var tab by remember { mutableStateOf(if (phoneLayout) "自选" else "研究") }
    LaunchedEffect(requestedFilter) {
        if (requestedFilter != null) tab = "自选"
    }
    LaunchedEffect(openResearchNonce, openResearchRequest) {
        if (openResearchNonce > 0 || openResearchRequest) {
            tab = "研究"
            onOpenResearchConsumed()
        }
    }
    Column(Modifier.fillMaxSize()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(StockColors.Card)
                .padding(
                    horizontal = if (phoneLayout) 8.dp else 12.dp,
                    vertical = if (phoneLayout) 6.dp else 8.dp,
                ),
            horizontalArrangement = Arrangement.spacedBy(if (phoneLayout) 6.dp else 8.dp),
        ) {
            listOf("自选", "研究", "智启").forEach { item ->
                val selected = tab == item
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .background(
                            if (selected) StockColors.UpSoft else StockColors.Background,
                            RoundedCornerShape(8.dp),
                        )
                        .clickable { tab = item }
                        .padding(vertical = if (phoneLayout) 9.dp else 10.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Text(
                        text = item,
                        color = if (selected) StockColors.UpRed else StockColors.TextSecondary,
                        fontWeight = if (selected) FontWeight.Bold else FontWeight.Medium,
                        fontSize = if (phoneLayout) 15.sp else 14.sp,
                    )
                }
            }
        }
        when (tab) {
            "自选" -> WatchlistPanel(
                stocks = stocks,
                browseStocks = browseStocks,
                paneTab = watchlistPaneTab,
                onPaneTabChange = onWatchlistPaneTabChange,
                selectedCode = selectedCode,
                holdingCodes = holdings.keys,
                scanByCode = scanByCode,
                scanChanges = scanChanges,
                groupByCode = groupByCode,
                scanSummary = scanSummary,
                scanAlertText = scanAlertText,
                scanPrefs = scanPrefs,
                requestedFilter = requestedFilter,
                scanning = scanning,
                onAddWatch = onAddWatch,
                onRemoveWatch = onRemoveWatch,
                onRemoveBrowse = onRemoveBrowse,
                onScanQuant = onScanQuant,
                onDismissAlert = onDismissAlert,
                onAlertActivate = {
                    onAlertActivate()
                    tab = "自选"
                },
                onOpenHistory = onOpenHistory,
                onOpenPortfolio = onOpenPortfolio,
                onOpenPaperTrades = onOpenPaperTrades,
                onCycleGroup = onCycleGroup,
                onGroupMapChange = onGroupMapChange,
                onExportScan = onExportScan,
                onOpenBackup = onOpenBackup,
                layoutLabel = layoutLabel,
                onCycleLayout = onCycleLayout,
                onScanPrefsChange = onScanPrefsChange,
                onFilterRequestConsumed = onFilterRequestConsumed,
                onSelect = {
                    onSelect(it)
                    tab = "研究"
                },
                phoneLayout = phoneLayout,
                modifier = Modifier.fillMaxSize(),
            )
            "智启" -> AiAssistantPanel(
                stock = selectedStock,
                metrics = metrics,
                holding = holdings[selectedStock.code],
                candles = candles,
                adaptiveLearning = adaptiveLearning,
                watchlistCodes = watchlistCodes,
                onEditHolding = onAddHolding,
                onScanResult = onScanResult,
                onQuantUpdated = onQuantUpdated,
                modifier = Modifier.fillMaxSize(),
            )
            else -> ResearchPanel(
                stock = selectedStock,
                metrics = metrics,
                isLive = isLive,
                holding = holdings[selectedStock.code],
                isInWatchlist = selectedCode in watchlistCodes,
                canRemoveWatch = watchlistCodes.size > 1,
                scan = scanByCode[selectedStock.code],
                recommendReasons = recommendReasons,
                recommendRisks = recommendRisks,
                tradeMarkers = tradeMarkers,
                recommendHistory = recommendHistory,
                onAddHolding = onAddHolding,
                onAddWatch = onAddCurrentWatch,
                onRemoveWatch = { onRemoveWatch(selectedStock.code) },
                onSetAlert = onSetAlert,
                modifier = Modifier.fillMaxSize(),
            )
        }
    }
}

@Composable
private fun DividerLine() {
    Box(
        Modifier
            .width(1.dp)
            .fillMaxSize()
            .background(StockColors.Border),
    )
}
